/* istanbul ignore file */
/**
 * Get a stored session ID
 * @return {(string | null)}
 */
export function getSessionId() {
    return null;
}

/**
 * Store a session ID
 * @param {string} value session ID
 */
export function setSessionId(value) {
}
